import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'src/_common/hooks/useTranslation'

interface FooterProps {
  variant?: 'default' | 'dashboard';
}

export default function Footer({ variant = 'default' }: FooterProps) {
  const { t } = useTranslation('dashboard');
  
  if (variant === 'dashboard') {
    return (
      <footer className="drjob-footer">
        <div className="drjob-footer-container">
          <p className="drjob-footer-text">
            {t('dashboard.footer.copyright', { year: moment().format("YYYY") })}
          </p>
        </div>
      </footer>
    );
  }

  // Default footer
  return null;
}